import { axiosClient } from '../http/axios-client';
import { IFileUploadService } from '@gishub/domain';

export class GeoFileUploadService implements IFileUploadService {
  readAsText(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = () => reject(new Error('Error reading file'));
      reader.readAsText(file);
    });
  }

  async upload(file: File): Promise<any> {
    const formData = new FormData();
    formData.append('file', file);
    const res = await axiosClient.post('/files/shapefile/geojson', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60_000,
    });
    return res.data;
  }
}

